export const OFFSET_LIVE_CHAT=20
//API key 3
export const YOUTUBE_VIDEOS_API="https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&regionCode=IN&maxResults=50&key="+process.env.REACT_APP_KEY2

export const YOUTUBE_SEARCH_API="https://clients1.google.com/complete/search?client=youtube&gs_ri=youtube&ds=yt&q="